module.exports = __webpack_public_path__ + "static/img/fence_256.c9c5486.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fence_256.png
// module id = HVws
// module chunks = 0